document.addEventListener('cart:updated', checkPreorderTag);
document.addEventListener('DOMContentLoaded', checkPreorderTag);

function checkPreorderTag() {
  const cartItems = document.querySelectorAll('.cart-item');
  const noteBox = document.querySelector('textarea[name="note"]');
  const msg = 'Acest produs este disponibil pentru precomandă. Timp estimat de livrare: 2–3 săptămâni.';

  if (!noteBox || cartItems.length === 0) return;

  let hasPreorder = false;

  cartItems.forEach((item) => {
    const tags = item.getAttribute('data-product-tags') || '';
    if (tags.includes('precomanda')) {
      hasPreorder = true;
    }
  });

  if (hasPreorder) {
    if (!noteBox.value.includes(msg)) {
      noteBox.value = msg;
      noteBox.dispatchEvent(new Event('input', { bubbles: true }));
    }
  } else {
    if (noteBox.value === msg) {
      noteBox.value = '';
      noteBox.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }
}
